import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { config } from "../../config";

function Footer() {
  return (
    <footer className="bg-gray-100 py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start mb-8">
          {/* Logo Section */}
          <div className="mb-8 md:mb-0">
            <img src="footer-logo.png" alt="Logo" className="h-14 w-auto mb-4" />
          </div>

          {/* Links Section */}
          <div className="flex gap-8">
            <Link
              to="/flights/booking/search"
              className="block text-gray-600 hover:font-bold transition-all"
            >
              Manage my booking
            </Link>

            <Link
              to="/about-us"
              className="block text-gray-600 hover:font-bold transition-all"
            >
              About us
            </Link>
          </div>

          {/* Social Links */}
          <div className="flex space-x-4 mt-8 md:mt-0">
            <a
              href={config.socialLinks.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-gray-900"
            >
              <FontAwesomeIcon icon={faLinkedin} size="lg" />
            </a>
            
            <a
              href={config.socialLinks.twitter}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-600 hover:text-gray-900"
            >
              <FontAwesomeIcon icon={faTwitter} size="lg" />
            </a>
         
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t text-sm pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex space-x-6 mb-4 md:mb-0">
              <Link
                to="/privacy-policy"
                className="text-gray-500 hover:font-bold"
              >
                Privacy
              </Link>
              <Link
                to="/terms-conditions"
                className="text-gray-500 hover:font-bold"
              >
                Terms
              </Link>
            </div>
            <div className="flex items-center space-x-4">
              <img src="/atol.svg" alt="ATOL" className="h-8" />
              <img src="/iata.svg" alt="IATA" className="h-8" />
            </div>
          </div>
          <div className="text-center text-sm text-gray-500 mt-4">
            {`${config.companyInfo.name} - ${config.companyInfo.copyright}`}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
